import { Toggle } from "@fluidattacks/design";
import React, { useCallback, useContext } from "react";
import { useParams } from "react-router-dom";

import { usePermissions } from "context/authz/hooks/use-permissions";
import { meetingModeContext } from "context/meeting-mode";
import { useAudit } from "hooks/use-audit";
import { useAuthz } from "hooks/use-authz";
import { useSettingsStore } from "hooks/use-settings-store";

const CVSS3Toggle = (): React.ReactNode => {
  const { can } = useAuthz();
  const { someGroupPermissions } = usePermissions();
  const { meetingMode } = useContext(meetingModeContext);
  const canSeeCvss3 =
    can("see_cvss_3") || someGroupPermissions.can("see_cvss_3");
  const { groupName } = useParams() as { groupName: string };
  const { cvssVersion, setCvssVersion } = useSettingsStore();

  const { addAuditEvent } = useAudit();

  const onChangeCvssVersion = useCallback((): void => {
    addAuditEvent("CVSSToggle", groupName);
    setCvssVersion(cvssVersion.value === "v4.0" ? "v3.1" : "v4.0");
  }, [addAuditEvent, cvssVersion, groupName, setCvssVersion]);

  return (
    canSeeCvss3 &&
    !meetingMode && (
      <Toggle
        defaultChecked={cvssVersion.value === "v4.0"}
        leftDescription={"CVSS 3.1"}
        name={"cvssToggle"}
        onChange={onChangeCvssVersion}
        rightDescription={"CVSS 4.0"}
      />
    )
  );
};

export { CVSS3Toggle };
